import React from "react";
import { Route, Routes } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";

/**
 * The authentication screen.
 *
 * `LoginProvider` renders this in place of the whole application whenever there
 * is no session, so it stands in for every path — which is why the fallback
 * route is `*` rather than `/login`. It sits inside the app's `BrowserRouter`
 * (see `App.tsx`), so `/forgot-password` is a real URL: it is reachable
 * directly, it is bookmarkable, and the browser back button works.
 *
 * `AuthLayout` is outside the `<Routes>` on purpose. The branding panel, the
 * background, the card position and the footer are then genuinely the same DOM
 * across both screens rather than two copies that happen to match, and moving
 * between them does not re-mount the shell or restart its entrance animation.
 */
const Auth: React.FC = () => (
  <AuthLayout>
    <Routes>
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="*" element={<Login />} />
    </Routes>
  </AuthLayout>
);

export default Auth;
